@if (content?.video_id) {
  <div class="ratio-16-9 m-l--4-s m-r--4-s"
    >
    <youtube-player class="fill"
      [video-id]="content.video_id"
      [controls]="false">
    </youtube-player>
  </div>
}